import React from 'react';
import s from 'components/BackgroundImageDayReport/BackgroundImageDayReportBotPosition.module.css';

const BackgroundImageDayReportBotPosition = () => {
  return <div className={s.backgroundImageBot} />;
};

export default BackgroundImageDayReportBotPosition;
